module.exports = __webpack_public_path__ + "img/slide-12.b5adbe48.png";